import { BaseController } from '@shared/basecontroller.controller';
import { LinkBankFormErrorModel } from '@shared/system-components/link-bank-widget/model/form-error.model';
import { RequestLinkBankForm } from '@shared/system-components/link-bank-widget/model/form.model';
import EVENTS from '@shared/events';

export class BankAccountController extends BaseController {
  constructor(PaymentOptionApiService, FormService, PageService, EventDispatcherService, AppService, $timeout, $scope, $translate) {
    'ngInject';

    super();

    this.PaymentOptionApiService = PaymentOptionApiService;
    this.FormService = FormService;
    this.PageService = PageService;
    this.EventDispatcherService = EventDispatcherService;
    this.AppService = AppService;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$translate = $translate;

    this.$scope.$on('reload.member-payment-option', () => {
      this.getBankPaymentOptionList();
    });
  }

  $onInit() {
    this.error = new LinkBankFormErrorModel();
    this.form = new RequestLinkBankForm();
    this.addSubscription(this.EventDispatcherService.addListener(EVENTS.MEMBER_PAYMENT_OPTION_CREATED, event => this.getBankPaymentOptionList()));
    this.getBankPaymentOptionList();
  }

  getBankPaymentOptionList() {
    this.PaymentOptionApiService.getBankPaymentOption().then((resp) => {
      this.form.bankDetails = resp;
    });
  }

  editBankAccountDetails(id) {
    this.error.hasError = true;
    this.PaymentOptionApiService.getPaymentOptionById(id).then((resp) => {
      this.form.bankPaymentOption = id;
      this.form.beneficiaryAccount = resp.fields.account_id;
      this.form.beneficiaryAccountName = resp.fields.account_name;
      this.form.beneficiaryAddress = resp.fields.account_address;
      this.form.dateOfBirth = resp.fields.birth_date;
      this.form.citizenship = resp.fields.citizenship;
      this.form.beneficiaryCode = resp.fields.swift_code;
      this.form.bankAddress = resp.fields.bank_address;
      this.form.beneficiaryBank = resp.fields.bank_name;
      this.form.isDefault = resp.fields.is_default;
      this.form.responseData = resp;
      this.$timeout(() => {
        this.AppService.broadcast('reload.bank-details');
      }, 200);
    });
  }

  confirmDelete(id) {
    this.error.errorMessage.body = this.$translate.instant('Are you sure you want to delete this Bank Account?');
    this.form.bankPaymentOption = id;
    this.PageService.showModal('errorBankAccountModal');
  }

  deleteBankAccount() {
    $('#errorBankAccountModal').modal('hide');
    this.PaymentOptionApiService.deleteBankAccountRequest(this.form.toDeletePayload())
    .then((resp) => {
      this.PageService.showModal('successModal');
      this.$timeout(() => {
        $('#successModal').modal('hide');
        this.getBankPaymentOptionList();
      }, 2000);
    })
    .catch((errors) => {
      this.error.errorMessage.body = errors[0];
      this.$timeout(() => {
        this.PageService.showModal('errorModal');
      }, 500);
    });
  }

  resetForm() {
    this.form.reset();
    this.error.clearFormErrors();
    this.FormService.isSubmitting.next(false);
  }

  openBankAccountModal() {
    this.resetForm();
    this.PageService.showModal('bankAccountModal');
  }
}

export default BankAccountController;


// WEBPACK FOOTER //
// ./client/app/pages/settings/component/bank-account/bank-account.controller.js